import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as config from "../../../../constants/config";
import * as actions from "../../../../actions/serverActions";

class ReconnectPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            editActive: false,
            ip: this.props.activeServer !== null ? this.props.activeServer.ip : config.LOCALHOST
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.activeServer === null && prevState.ip !== "") {
            return {
                ip: ""
            };
        }

        if (!prevState.editActive && nextProps.activeServer !== null && prevState.ip === "") {
            return {
                ip: nextProps.activeServer.ip
            };
        }

        return null;
    }

    handleEditUrlClick = () => {
        this.setState({editActive: true});
    };

    handleUrlInputChange = (event) => {
        this.setState({ip: event.target.value});
    };

    handleUrlInputBlur = () => {
        this.setState({editActive: false});
    };

    handleReconnectClick = () => {
        this.props.dispatchSetActiveServerByUrlAction(this.getWebsocketUrl());
    };

    getWebsocketUrl = () => {
        return config.WEBSOCKET_PROTOCOL + this.state.ip + ":" + config.SERVER_PORT;
    };

    getUrlContent = () => {
        if (this.state.editActive) {
            return (
                <input
                    type="text"
                    value={this.state.ip}
                    onChange={this.handleUrlInputChange}
                    onBlur={this.handleUrlInputBlur}
                    autoFocus
                />
            );
        }

        return (
            <a onClick={this.handleEditUrlClick} style={{color: "#ffffff"}} href="# ">
                {this.getWebsocketUrl()}
            </a>
        );
    };

    render() {
        return (
            <div className="connection-info" style={{WebkitAppRegion: "no-drag"}}>
                <span>
                    <Translate value="welcome.lostConnection" /> | {this.getUrlContent()}
                    <button
                        className="btn btn-primary btn-xs"
                        onClick={this.handleReconnectClick}
                        style={{marginLeft: "15px"}}
                    >
                        <Translate value="general.reconnect" />
                    </button>
                </span>
            </div>
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        activeServer: store.server.activeServer
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchSetActiveServerByUrlAction: (url) => {
            dispatch(actions.setActiveServerByUrl(url));
        }
    };
};

export default ReconnectPanel = connect(mapStoreToProps, mapDispatchToProps)(ReconnectPanel);
